<template>
  <v-container fluid class="itemcategory-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex flex-start justify-md-start">
              <v-btn to="/itemcategory/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="itemcategories-table"
              show-select
              single-select
              item-key="_id"
              sort-by="itemcategoryname"
              :footer-props="footer"
              :headers="headers"
              :items="itemcategories"

              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Item Category?
                    </v-card-title>

                    <v-card-text>
                      {{ deleteItemCategory.itemcategoryname }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deleteItemCategory)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.image="{ item }">
                <v-avatar v-if="item.itemcategoryimage" size="35">
                  <img v-bind:src="item.itemcategoryimage" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="35">
                  <span class="white--text headline">{{ item.itemcategoryname[0].toUpperCase() }}</span>
                </v-avatar>
              </template>
              <template v-slot:item.itemcategoryname="{ item }">
                <a class="primaryConst--text">{{ item.itemcategoryname }}</a>
              </template>
              <template v-slot:item.itemgroupid="{ item }">
                {{ 
                  item.itemgroupid !== null && itemgroups.find(itemgroup=>itemgroup._id == item.itemgroupid) !== undefined ? itemgroups.find(itemgroup=>itemgroup._id == item.itemgroupid)['itemgroupname'] : ''
                }}
              </template>
              <template v-slot:item.itemcategorystatus="{ item }">
                <v-chip
                  :color="getStatusColor(item.itemcategorystatus)"
                  small>
                  {{ item.itemcategorystatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-US", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'
import { getStatusColor } from "../../../util/tools";

export default {
  name: 'itemcategoryList',
  data() {
    return {
      config,
      snackbar: null,
      dialog: false,
      deleteItemCategory: {},
      headers: [
        { text: 'Image', value: 'image', sortable: false },
        { text: 'Group', value: 'itemgroupid' },
        { text: 'Name', value: 'itemcategoryname' },
        { text: 'Code', value: 'itemcategorycode' },
        { text: 'Status', value: 'itemcategorystatus' },
        { text: 'Create', value: 'createdAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
      selected: [],
      getStatusColor: getStatusColor,
    }
  },

  computed: {
    ...mapState('ItemCategory', ['itemcategories', 'isReceiving', 'isDeleting', 'idToDelete', 'itemcategoriesMessage', 'isUpdating']),
    ...mapState('ItemGroup', ['itemgroups']),
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit itemcategory'
    },
  },

  created () {
    this.getItemCategoriesRequest();
    if(this.itemgroups.length==0){
      this.getItemGroupsRequest();
    }
    console.log(this.itemcategories);
    console.log(this.itemgroups);
  },

  methods: {
    ...mapActions('ItemCategory', ["getItemCategoriesRequest","deleteItemCategoryRequest","updateItemCategoryRequest","createItemCategoryRequest"]),
    ...mapActions('ItemGroup', ["getItemGroupsRequest"]),
    editItem(item) {
      this.$router.push({ name: 'ItemCategoryEdit', params: item })
    },

    deleteItem(item) {
      this.deleteItemCategoryRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deleteItemCategory = {
        _id: item._id,
        itemcategoryname: item.itemcategoryname,
      }
    },
    close () {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1
      })
    },


    addSuccessNotification() {
      this.snackbar = true;
      this.color = config.light.success;
      this.text = this.notification;
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
